module.exports = __webpack_public_path__ + "static/img/twjd-sde7-2.3ca5ff2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sde7-2.png
// module id = 845
// module chunks = 0